// removed by extract-text-webpack-plugin
module.exports = {"root":"root__PqsSH","title":"title__1Y1VF","related":"related__1Yq4s","article":"article__3zmHB","name":"name__2aEAs","image":"image__16Nfu"};


//////////////////
// WEBPACK FOOTER
// ./components/RelatedContent/style.css
// module id = iOXE
// module chunks = 0